import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, Grid, Typography, Tooltip } from "@mui/material";
import { API_LoginURL } from "../../../config";
import Navbar from "../../Header/header";
import SASidebar from "../SuperAdmin/Superadmincom/SuperAdminSidebar";
import '../AdminDashboard/AdminDashContent/AdminHome/AdminHome.css'
import TotalStudents from '../AdminDashboard/AdminDashContent/AdminHome/totalStudents.png'
import ActiveStudents from '../AdminDashboard/AdminDashContent/AdminHome/activeStudents.png'
import InactiveStudents from '../AdminDashboard/AdminDashContent/AdminHome/inactiveStudents.png'
import grade6 from '../AdminDashboard/AdminDashContent/AdminHome/grade6.png'
import grade7 from '../AdminDashboard/AdminDashContent/AdminHome/grade7.png'
import grade8 from '../AdminDashboard/AdminDashContent/AdminHome/grade8.png'
import grade9 from '../AdminDashboard/AdminDashContent/AdminHome/grade9.png'
import grade10 from '../AdminDashboard/AdminDashContent/AdminHome/grade10.png'

export default function SuperAdminDashboard() {
  const [totalAdmins, setTotalAdmins] = useState(0);
  const [totalTeachers, setTotalTeachers] = useState(0);
  const [totalStudents, setTotalStudents] = useState(0);
  const [activeStudents, setActiveStudents] = useState(0);
  const [inactiveStudents, setInactiveStudents] = useState(0);
  const [studentsPerClass, setStudentsPerClass] = useState({});

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_LoginURL}user/UserList`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Fetch Users Error:", error);
      return [];
    }
  };

  useEffect(() => {
    const getUserStats = async () => {
      try {
        const response = await fetchUsers();
        // Ensure users is an array, default to empty array if not
        const users = Array.isArray(response) ? response : [];
        
        // Count by role - no optional chaining needed since we ensured users is array
        const admins = users.filter(u => u.role === 'Admin').length;
        const teachers = users.filter(u => u.role === 'Teacher').length;
        const students = users.filter(u => u.role === 'Student').length;
        
        // Student status counts
        const active = users.filter(u => u.role === 'Student' && u.isActive === false).length;
        const inactive = users.filter(u => u.role === 'Student' && u.isActive === true).length;
        
        // Class-wise counts for students only
        const classCounts = users.reduce((acc, user) => {
          if (user.role === 'Student') {
            acc[user.className] = acc[user.className] || { count: 0, students: [] };
            acc[user.className].count += 1;
            acc[user.className].students.push(`${user.firstName} ${user.lastName}`);
          }
          return acc;
        }, {});

        setTotalAdmins(admins);
        setTotalTeachers(teachers);
        setTotalStudents(students);
        setActiveStudents(active);
        setInactiveStudents(inactive);
        setStudentsPerClass(classCounts);
      } catch (error) {
        console.error('Error fetching user stats:', error);
        // Optionally set default/empty states here if the request fails
      }
    };
    getUserStats();
  }, []);

  return (
    <div class="container-scroller">
      <Navbar />
      <div class="container-fluid page-body-wrapper">
        <SASidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className='adminHomeMain'>
                    <div className='adminHomeUpper'>
                      <div className='adminHomeCard'>
                        <div className='adminHomeCardLeft'>
                          <p>Total Admin</p>
                          <h1>{totalAdmins}</h1>
                        </div>
                        <div className='adminHomeCardRight'>
                          <img src={TotalStudents} alt="Total Admins" />
                        </div>
                      </div>
                      <div className='adminHomeCard'>
                        <div className='adminHomeCardLeft'>
                          <p>Total Teacher</p>
                          <h1>{totalTeachers}</h1>
                        </div>
                        <div className='adminHomeCardRight'>
                          <img src={ActiveStudents} alt="Total Teachers" />
                        </div>
                      </div>
                      <div className='adminHomeCard'>
                        <div className='adminHomeCardLeft'>
                          <p>Total Students</p>
                          <h1>{totalStudents}</h1>
                        </div>
                        <div className='adminHomeCardRight'>
                          <img src={InactiveStudents} alt="Total Students" />
                        </div>
                      </div>
                    </div>
                    <div className='adminHomeUpper'>
                      <div className='adminHomeCard'>
                        <div className='adminHomeCardLeft'>
                          <p>Active Students</p>
                          <h1>{activeStudents}</h1>
                        </div>
                        <div className='adminHomeCardRight'>
                          <img src={ActiveStudents} alt="Active Students" />
                        </div>
                      </div>
                      <div className='adminHomeCard'>
                        <div className='adminHomeCardLeft'>
                          <p>Inactive Students</p>
                          <h1>{inactiveStudents}</h1>
                        </div>
                        <div className='adminHomeCardRight'>
                          <img src={InactiveStudents} alt="Inactive Students" />
                        </div>
                      </div>
                      <div className='adminHomeCard'>
                        <div className='adminHomeCardLeft'>
                          <p>Total Users</p>
                          <h1>{totalAdmins + totalTeachers + totalStudents}</h1>
                        </div>
                        <div className='adminHomeCardRight'>
                          <img src={TotalStudents} alt="Total Users" />
                        </div>
                      </div>
                    </div>
                    <div className='adminHomeLower'>
                      <div className='adminHomeLowerInner'>
                        {Object.entries(studentsPerClass).map(([className, data]) => (
                          <Tooltip key={className} title={data.students.join(", ")} arrow>
                            <div className='adminHomeCard lower'>
                              <div className='adminHomeCardLeft'>
                                <p>{className}</p>
                                <h1>{data.count}</h1>
                              </div>
                              <div className='adminHomeCardRight'>
                                <img src={
                                  className.includes("6") ? grade6 :
                                  className.includes("7") ? grade7 :
                                  className.includes("8") ? grade8 :
                                  className.includes("9") ? grade9 :
                                  grade10
                                } alt={className} />
                              </div>
                            </div>
                          </Tooltip>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}